export default __webpack_public_path__ + "static/bg-left-58257012c33e05034a56dd8c5d4e6c6c.jpg";